module.exports = __webpack_public_path__ + "static/media/svg12.2b3f4431.svg";